import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/nfAvulsa/';

class NotaFiscalAvulsaService {
    constructor() {
        this.idCliente = null;
        this.idContribuinte = null;
        this.idUsuario = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    gerarDamNotaAvulsa(idNfs, vencimento) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'lancamento?idCliente=' + this.idCliente
            + '&idUsuario=' + this.idUsuario
            + '&idNfs='+ idNfs
            + '&vencimento=' + vencimento, null, {headers: this.headers});
    }

    cancelarDamNotaAvulsa(idNfs) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'cancelarDam?idCliente=' + this.idCliente
            + '&idUsuario=' + this.idUsuario
            + '&idNfs='+ idNfs, null, {headers: this.headers});
    }

    atualizarVencimento(idNotaAvulsaSelecionada, dataVencimento){
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.post(API_URL+'atualizarVencimento?idNfs='+idNotaAvulsaSelecionada
            + '&idCliente=' + this.idCliente
            + '&dataVencimento='+dataVencimento, null, {headers: this.headers});
    }

    verificaDamGerado(idNota){
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.post(API_URL+'verificaDamGerado?idNfs='+idNota
            + '&idCliente=' + this.idCliente, null, {headers: this.headers});
    }

    criarPagamentoPix(idNotaAvulsa){
        return axios.post(API_URL+'criarPagamentoPix?idNotaAvulsa='+idNotaAvulsa, null, {headers: this.headers});
    }

    
    criarPagamentoPixCp(idNotaAvulsa, idCalculoParcelado){
        return axios.post(API_URL+'criarPagamentoPixCp?idNotaAvulsa='+idNotaAvulsa+'&idCalculoParcelado='+idCalculoParcelado, null, {headers: this.headers});
    }

    consultarPagamentoPix(idNotaAvulsa){
        return axios.get(API_URL + 'consultarPagamentoPix?idNotaAvulsa='+idNotaAvulsa, {headers: this.headers});
    }

    calcularImpostosFederais(ano, mes, baseCalculoNota, paramImpFederalDependentes, paramImpFederalDeducaoINSS, paramImpFederalPercIRRF, paramImpFederalPercINSS, paramImpFederalAliqSEST, paramImpFederalAliqSENAT) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idCntPrestador = LoginService.currentUserValue.contribuinte.idContribuinte;
        
        return axios.post(API_URL + 'calcularImpostosFederais'
            + '?idCliente=' + this.idCliente
            + '&idCntPrestador=' + this.idCntPrestador
            + '&ano=' + ano + '&mes=' + mes
            + '&baseCalculoNota=' + baseCalculoNota
            + '&impFederalDependentes=' + paramImpFederalDependentes
            + '&impFederalDeducaoINSS=' + paramImpFederalDeducaoINSS
            + '&impFederalPercIRRF=' + paramImpFederalPercIRRF
            + '&impFederalPercINSS=' + paramImpFederalPercINSS
            + '&impFederalAliqSEST=' + paramImpFederalAliqSEST
            + '&impFederalAliqSENAT=' + paramImpFederalAliqSENAT, null, {headers: this.headers});
    }
}

export default new NotaFiscalAvulsaService();